import { CircularProgress, type CircularProgressProps } from "@mui/material";
import type { FunctionComponent, PropsWithChildren } from "react";

type Props = {
	size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
	customSize?: number;
} & CircularProgressProps;

const sizeMap = {
	xxs: 10,
	xs: 12,
	sm: 14,
	md: 16,
	lg: 18,
	xl: 20,
	xxl: 40, //default size for CircularProgress
};

export const SabCircularProgress: FunctionComponent<
	PropsWithChildren<Props>
> = ({ size, customSize, ...rest }) => {
	return (
		<CircularProgress
			{...rest}
			size={sizeMap[size ?? "md"]}
			style={customSize ? { width: customSize, height: customSize } : undefined}
		/>
	);
};
